import Cookies from 'js-cookie';

function clearAllCookies() {
    const allCookies = Cookies.get();
    Object.keys(allCookies).forEach((cookieName) => {
        Cookies.remove(cookieName);
    });
}
export default clearAllCookies;
